import { ADD_MEGAMENU_HISTORY } from 'redux/modules/mega-menu/actions/types';

export default level => ({
  level,
  type: ADD_MEGAMENU_HISTORY,
});
